const Messenger = () => {
   return (
      <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
         <g fillRule="evenodd" clipPath="url(#iconFBMessenger)" clipRule="evenodd">
            <path fill="url(#paint0_radial)"
               d="M8 0C3.493 0 0 3.301 0 7.76c0 2.332.956 4.348 2.512 5.74.131.117.21.28.215.456l.044 1.423a.64.64 0 00.898.566l1.588-.701a.639.639 0 01.427-.031c.73.2 1.507.307 2.316.307 4.507 0 8-3.301 8-7.76S12.507 0 8 0z">
            </path>
            <path fill="#fff"
               d="M3.196 10.03L5.546 6.3a1.2 1.2 0 011.735-.32l1.87 1.402a.48.48 0 00.578-.002l2.524-1.916c.337-.255.777.148.551.506l-2.35 3.728a1.2 1.2 0 01-1.735.32l-1.87-1.402a.48.48 0 00-.577.002l-2.525 1.916c-.337.255-.776-.148-.551-.506z">
            </path>
         </g>
         <defs>
            <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientTransform="translate(3.08 15.914) scale(17.4336)"
               gradientUnits="userSpaceOnUse">
               <stop stopColor="#09F"></stop>
               <stop offset="0.61" stopColor="#A033FF"></stop>
               <stop offset="0.935" stopColor="#FF5280"></stop>
               <stop offset="1" stopColor="#FF7061"></stop>
            </radialGradient>
            <clipPath id="iconFBMessenger">
               <path fill="#fff" d="M0 0H16V16H0z"></path>
            </clipPath>
         </defs>
      </svg>
   )
}

export default Messenger;